import AppHeader from "../AppHeader";
import AppFooter from "../AppFooter";
import InternetConnectionHandler from "src/components/Common/NoInternet/InternetConnectionHandler";

const AppLayout = ({ children }) => {
  return (
    <InternetConnectionHandler>
      <div className="min-h-screen flex flex-col">
        <div className="w-full flex justify-center">
          <div className="w-full max-w-[1920px]">
            <AppHeader />
            <main className="bg-background-primary">{children}</main>
            <AppFooter />
          </div>
        </div>
      </div>
    </InternetConnectionHandler>
  );
};

export default AppLayout;
